import PropTypes from "prop-types";
import React from "react";

export default function SubscriptionCardDesign({ whatsDesign, mobileViewCardDesign, isMobile, item, image, similarCard }) {
  const dimensions = () => {
    if (whatsDesign) {
      return isMobile ? "w-[87px] h-[60px]" : "w-[140px] h-[140px]";
    } else if (mobileViewCardDesign) {
      return isMobile ? "sm:w-[100px] mobileViewSubscriptionDesign sm:h-[100px]" : "w-[140px] h-[140px]";
    } else if (similarCard && isMobile) {
      return "w-[100px] h-[100px]";
    }
    return "w-[140px] h-[140px]";
  };

  return (
    <div
      className={`${dimensions()} flex justify-center bg-cover items-center rounded-[10px] drop-shadow-md bg-no-repeat bg-center`}
      style={{ backgroundImage: `url('${image}')`, backgroundColor: `#${item?.brand?.hex_code}`, }}
    >
      {!image && (
        <div className={`text-xl text-center ${item?.brand?.hex_code === "FFFFFF" ? "text-black" : "text-white"}`}>
          {item?.brand?.name}
        </div>
      )}
      {/* {!whatsDesign && <RibbonTag showText={showText} channels={item?.redemption_channel} />} */}
    </div>
  );
};

SubscriptionCardDesign.propTypes = {
  mobileViewCardDesign: PropTypes.bool,
  isMobile: PropTypes.bool,
  item: PropTypes.shape({
    brand: PropTypes.shape({
      hex_code: PropTypes.string,
      name: PropTypes.string,
    }),
    redemption_channel: PropTypes.arrayOf(PropTypes.string),
  }),
  image: PropTypes.string,
};